// extracted by mini-css-extract-plugin
export default {"errorFallback":"errorFallback_errorFallback__Vy-ae","title2":"errorFallback_title2__k3ace"};